<div class="ClosableWindow"  v-show="show">

    <!-- 
    ATTENTION: v-show must be added to the panel element and *not* the socket.
    When the panel is floating/undocked, the socket is not its parent element.
    Instead, it's the document body. This means that v-show=false on the socket would
    have no effect on undocked panels.
    -->
    
    <div ref="panel">    
        <div>

            <slot />
            <!-- NOTE: The class 'FloatingWindow__DockButton' is required to animate the button! -->
            <SmartButton class="Button" @click="onCloseButtonClick">
                <img src="tivigi/img/remove.svg" class="Button_icon"/>               
            </SmartButton>
        </div>

    </div>
</div>
